import type { InstallmentStatus } from "@/types/installment";
import { INSTALLMENT_STATUS_META, DEFAULT_INSTALLMENT_STATUS_META } from "../data";

interface Props {
  status?: InstallmentStatus | string | null;
  size?: "sm" | "md";
}

export default function InstallmentStatusBadge({ status, size = "md" }: Props) {
  const normalizedKey = (status ? String(status).trim().toUpperCase() : "") as InstallmentStatus;
  const meta =
    INSTALLMENT_STATUS_META[normalizedKey] || {
      ...DEFAULT_INSTALLMENT_STATUS_META,
      label: status ? String(status).replace(/_/g, " ") : "Scheduled",
    };

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-medium ${meta.bg || "bg-slate-100"} ${meta.text || "text-slate-600"} ${
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot || "bg-slate-400"}`} />
      {meta.label}
    </span>
  );
}